export default __webpack_public_path__ + "static/media/screenshot-06.79c3ab90.png";